import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  treeNode: {
    '.ant-tree-indent': {
      whiteSpace: 'normal',
      opacity: 0
    },
    '.ant-tree-indent-unit': {
      width: 64,
      whiteSpace: 'nowrap !important'
    },
    '.ant-tree-treenode-leaf-last .ant-tree-switcher-leaf-line:before': {
      height: '33px !important'
    },

    '.ant-tree-treenode': {
      paddingBottom: 8,

      '.ant-tree-switcher': {
        width: 0
      },
      '.ant-tree-switcher:hover': {
        backgroundColor: 'transparent'
      },
      '.ant-tree-switcher svg': {
        display: 'none'
      },
      '.ant-tree-node-content-wrapper': {
        width: 'inherit'
      },
      '.ant-tree-node-content-wrapper:hover': {
        backgroundColor: 'transparent'
      },
      '.ant-tree-switcher-leaf-line': {
        marginLeft: -40
      },
      '.ant-tree-switcher-leaf-line::before': {
        bottom: -8,
        height: 107,
        insetInlineEnd: 10
      },
      '.ant-tree-switcher-leaf-line::after': {
        height: 33,
        width: 28,
        insetInlineEnd: -18
      }
    }
  },
  card: {
    border: `1px solid ${token.colorSplit}`,
    padding: '16px',
    color: `${token.colorText}A6`,

    '.ant-card-body': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: 0,
      '::before, ::after': {
        content: 'none'
      }
    }
  }
}))
